// src/pages/auth/AuthPage.jsx (убедись, что пути импорта правильные)
import React from 'react';
import AuthContainer from '../../features/auth-form/ui/AuthContainer'; // Путь к твоему контейнеру

export default function AuthPage() {
  return (
    <AuthContainer />
  );
}